module.exports = __webpack_public_path__ + "static/media/bsi.8786361b.png";